import React from "react";
import { useSearchParams } from "react-router-dom";

const WHITE_LOGO =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_twenty-proof/artifacts/m3wf26xs_20-Proof-Final-Logo-White.png";

const OPTIONS = [
  {
    id: 1,
    label: "Current — MacBook + coffee (tight crop)",
    img: "https://images.unsplash.com/photo-1593425546383-260c8b86730b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400&ixlib=rb-4.1.0",
    pos: "object-center",
  },
  {
    id: 2,
    label: "Laptop + cup, lots of warm wood",
    img: "https://images.unsplash.com/photo-1668630491137-6f39aec7ea33?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400&ixlib=rb-4.1.0",
    pos: "object-center",
  },
  {
    id: 3,
    label: "Top view desk, coffee + notebook (wide wood)",
    img: "https://images.pexels.com/photos/5827789/pexels-photo-5827789.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=2400",
    pos: "object-center",
  },
  {
    id: 4,
    label: "Laptop on rustic wooden desk (wide)",
    img: "https://images.unsplash.com/photo-1734208682292-df2643d0c8d9?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400&ixlib=rb-4.1.0",
    pos: "object-center",
  },
  {
    id: 5,
    label: "Book + laptop + coffee, cozy wood",
    img: "https://images.pexels.com/photos/30457088/pexels-photo-30457088.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=2400",
    pos: "object-center",
  },
  {
    id: 6,
    label: "Current photo, lower crop (more table)",
    img: "https://images.unsplash.com/photo-1593425546383-260c8b86730b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400&ixlib=rb-4.1.0",
    pos: "object-bottom",
  },
];

const HeroBlock = ({ o }) => (
  <section
    data-testid={`hero-option-${o.id}`}
    className="relative h-screen min-h-[560px] w-full flex items-center justify-center overflow-hidden"
  >
    <div className="absolute inset-0">
      <img src={o.img} alt={o.label} className={`w-full h-full object-cover ${o.pos}`} />
      <div className="absolute inset-0 bg-black/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/10 to-black/20" />
    </div>
    <div className="absolute top-5 left-6 z-20 bg-black/50 text-white font-sans-ui text-xs px-3 py-1.5 rounded-full">
      Option {o.id} — {o.label}
    </div>
    <div className="relative z-10 px-6 w-full flex flex-col items-center">
      <img
        src={WHITE_LOGO}
        alt="20 PROOF"
        className="w-[80vw] max-w-[520px] drop-shadow-[0_6px_36px_rgba(0,0,0,0.55)]"
      />
      <button className="mt-10 inline-flex items-center border border-white/70 text-white font-sans-ui text-[15px] px-9 py-3.5 rounded-full">
        Watch the latest episode
      </button>
    </div>
  </section>
);

const HeroPreview = () => {
  const [params] = useSearchParams();
  const opt = params.get("opt");
  const list = opt ? OPTIONS.filter((o) => String(o.id) === opt) : OPTIONS;
  return (
    <div className="bg-[#eceae5] min-h-screen">
      {list.map((o) => (
        <HeroBlock key={o.id} o={o} />
      ))}
    </div>
  );
};

export default HeroPreview;
